export enum HomeEnum {
    MODULE_ACCESS = 'View',
}